import { _Base } from "./_Base";
import { endpoints } from "./endpoints";

export class KeenAPI extends _Base {
  additionalCookies = null;
  constructor(_additionalCookies: any) {
    super();
    this.additionalCookies = _additionalCookies;
  }

  endPointRoot = process.env.REACT_APP_ROOT_T_REST;

  async cached() {
    const url =
      this.endPointRoot +
      "/admin/keen/query?ts=1722418865423&queryName=crm-prod-web-app-average-daily-usage-subscriber-trial";
    return await this.prepareGet(
      url,
      { additionalCookies: this.additionalCookies },
      null
    );
  }

  async getUsageAnalytics(payload: any) {
    let endPointRoot = process.env.REACT_APP_ROOT_T_API;
    const url =
      endPointRoot + endpoints.keen.root + endpoints.keen.crmUsage + "/";

    const response = await this.preparePost(
      url,
      { params: payload, additionalCookies: this.additionalCookies },
      null
    );
    return response;
  }
}

// const keenqueries: any = {
//   TRENDRATING_WEB_APP_AVERAGE_DAILY_USERS: {
//     name: "crm-prod-web-app-average-daily-usage-subscriber-trial",
//     // 'analysis_type': 'count_unique',
//     // 'filters': [
//     //     {
//     //         'operator': 'in',
//     //         'property_name': 'user_type',
//     //         'property_value': ['SUBSCRIBER', 'TRIAL']
//     //     },
//     //     {
//     //         'operator': 'eq',
//     //         'property_name': 'product',
//     //         'property_value': 'Trendrating Web App'
//     //     }
//     // ],
//     // 'interval': 'daily',
//     // 'target_property': 'user_id',
//     // 'timeframe': Timeframe.get(
//     //     'DATETIME_DAYS_AGO_TO_YESTERDAY',
//     //     90
//     // )
//   },
//   TRENDRATING_WEB_APP_EMAIL_CLIENT: {
//     analysis_type: "count",
//     filters: [
//       {
//         operator: "eq",
//         property_name: "product",
//         property_value: "Trendrating Daily Report",
//       },
//       // {
//       //     'operator': 'in',
//       //     'property_name': 'user_type',
//       //     'property_value': ['SUBSCRIBER', 'TRIAL']
//       // }
//     ],
//     group_by: ["keen_ua_parsed.browser.family"],
//     timeframe: timeframe.get("DATETIME_DAYS_AGO_TO_YESTERDAY", 90),
//   },
//   TRENDRATING_WEB_APP_EMAIL_CLIENT_VERSION: {
//     analysis_type: "count",
//     filters: [
//       {
//         operator: "eq",
//         property_name: "product",
//         property_value: "Trendrating Daily Report",
//       },
//       // {
//       //     'operator': 'in',
//       //     'property_name': 'user_type',
//       //     'property_value': ['SUBSCRIBER', 'TRIAL']
//       // }
//     ],
//     group_by: ["keen_ua_parsed.browser.family", "keen_ua_parsed.browser.major"],
//     timeframe: timeframe.get("DATETIME_DAYS_AGO_TO_YESTERDAY", 90),
//   },
//   TRENDRATING_WEB_APP_OPERATING_SYSTEM: {
//     analysis_type: "count",
//     filters: [
//       {
//         operator: "eq",
//         property_name: "product",
//         property_value: "Trendrating Web App",
//       },
//       {
//         operator: "in",
//         property_name: "user_type",
//         property_value: ["SUBSCRIBER", "TRIAL"],
//       },
//     ],
//     group_by: ["keen_ua_parsed.os.family"],
//     timeframe: timeframe.get("DATETIME_DAYS_AGO_TO_YESTERDAY", 90),
//   },
//   TRENDRATING_WEB_APP_OPERATING_SYSTEM_VERSION: {
//     analysis_type: "count",
//     filters: [
//       {
//         operator: "eq",
//         property_name: "product",
//         property_value: "Trendrating Web App",
//       },
//       {
//         operator: "in",
//         property_name: "user_type",
//         property_value: ["SUBSCRIBER", "TRIAL"],
//       },
//     ],
//     group_by: ["keen_ua_parsed.os.family", "keen_ua_parsed.os.major"],
//     timeframe: timeframe.get("DATETIME_DAYS_AGO_TO_YESTERDAY", 90),
//   },
//   TRENDRATING_WEB_APP_USER_AGENT: {
//     analysis_type: "count_unique",
//     filters: [
//       {
//         operator: "eq",
//         property_name: "product",
//         property_value: "Trendrating Web App",
//       },
//       {
//         operator: "in",
//         property_name: "user_type",
//         property_value: ["SUBSCRIBER", "TRIAL"],
//       },
//     ],
//     group_by: ["keen_ua_parsed.browser.family"],
//     target_property: "user_id",
//     timeframe: timeframe.get("DATETIME_DAYS_AGO_TO_YESTERDAY", 90),
//   },
//   TRENDRATING_WEB_APP_USER_AGENT_VERSION: {
//     analysis_type: "count_unique",
//     filters: [
//       {
//         operator: "eq",
//         property_name: "product",
//         property_value: "Trendrating Web App",
//       },
//       {
//         operator: "in",
//         property_name: "user_type",
//         property_value: ["SUBSCRIBER", "TRIAL"],
//       },
//     ],
//     group_by: ["keen_ua_parsed.browser.family", "keen_ua_parsed.browser.major"],
//     target_property: "user_id",
//     timeframe: timeframe.get("DATETIME_DAYS_AGO_TO_YESTERDAY", 90),
//   },
// };
